import { Component, ComponentRef, inject, Input, Output, Type, ViewContainerRef } from '@angular/core';
import { ApiHomeRow } from '@tytapp/api';
import { BehaviorSubject } from 'rxjs';
import { HomeCardComponentType, HomeCardComponentTypeRegistration } from './home-cards.service';

@Component({
    selector: 'tyt-home-card-component-host',
    template: ``,
    styles: [`:host { display: none; }`]
})
export class HomeCardComponentHost {
    private _componentClass: HomeCardComponentTypeRegistration;
    private _viewContainer = inject(ViewContainerRef);

    @Input()
    get componentClass() { return this._componentClass; }
    set componentClass(value) {
        if (this._componentClass === value)
            return;
        this._componentClass = value;
        this.render();
    }

    private _card: ApiHomeRow;

    @Input()
    get card() { return this._card; }
    set card(value) {
        this._card = value;
        if (this.component)
            this.component.card = value;
    }

    @Output() componentChanged = new BehaviorSubject<HomeCardComponentType>(null);

    get component() {
        return this.componentRef?.instance;
    }

    private componentRef: ComponentRef<HomeCardComponentType>;

    reload() {
        this.render();
    }

    private render() {
        this._viewContainer.clear();
        this.componentRef = this._viewContainer.createComponent(this.componentClass.type);
        this.component.card = this.card;
        Object.assign(this.component, this.componentClass.parameters);
        setTimeout(() => this.componentChanged.next(this.component));
    }
}